const domain = 'https://api.17epk.com/Customization'  //  https://api.17epk.com/     https://www.17epk.com/
const domainV06 = 'https://api.17epk.com/V0.6/'  //  https://api.17epk.com/     https://www.17epk.com/

// localStorage.setItem('userId',1102373) // 1102373  1142023
// localStorage.setItem('token','eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhcGkua2luZ3NtaXRoLmNvbS5jbiIsImtzaWQiOiIxMDAiLCJpYXQiOjE0NTIwNzI3NTUsImV4cCI6MTQ1MjY3NzU1NX0.F7hSClqAfG9jqP4V02AzH3bk4L1HFuyUjuMV50MWuJU')
// localStorage.setItem('matchid',1)
// localStorage.setItem('groupid',1)

export default {
    domain:domain,
    domainV06:domainV06
}



// WEBPACK FOOTER //
// ./src/api/api_url.js